import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function RegisterPage() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const r = await register(name, email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Account created");
      navigate("/");
    } else {
      toast.error(r.error);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center grain-bg p-8">
      <div className="w-full max-w-sm bg-white rounded-lg border border-slate-200 shadow-sm p-8">
        <div className="text-xs uppercase tracking-[0.18em] text-orange-600 font-semibold mb-3">
          Create account
        </div>
        <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
          Register as a citizen
        </h2>
        <p className="text-slate-500 text-sm mt-1">
          File complaints and track their progress.
        </p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <Label className="text-sm font-semibold text-slate-700">Full name</Label>
            <Input
              data-testid="register-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="mt-1.5 h-11"
            />
          </div>
          <div>
            <Label className="text-sm font-semibold text-slate-700">Email</Label>
            <Input
              data-testid="register-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1.5 h-11"
            />
          </div>
          <div>
            <Label className="text-sm font-semibold text-slate-700">Password</Label>
            <Input
              data-testid="register-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="mt-1.5 h-11"
            />
          </div>
          <Button
            type="submit"
            data-testid="register-submit"
            disabled={loading}
            className="w-full h-11 bg-orange-600 hover:bg-orange-700 text-white font-semibold"
          >
            {loading ? "Creating..." : "Create account"}
          </Button>
        </form>
        <div className="mt-4 text-center text-sm text-slate-500">
          Already registered?{" "}
          <Link to="/login" className="text-orange-600 font-semibold hover:underline">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
